import { get, auth } from '../index';
const ENDPOINT = '/session';

export const getSessions = () => {
  const url = `${ENDPOINT}/all`;

  return get(url, auth());
};
